import PropTypes from 'prop-types';
import styled from 'styled-components';

const ProductDescription = styled.ul`
  .resultGrid & {
    margin: 10px 0;
    color: #666;
    @media ${({ theme }) => theme.breakpoints.mobile} {
      display: none;
    }
  }

  .resultList {
    .product {
      .desc & {
        margin-top: 0;
        margin-bottom: 10px;
        color: #222;
        @media ${({ theme }) => theme.breakpoints.mobile} {
          text-align: left;
        }
      }
    }
  }
`;

const ListItemOutfitsInfo = ({ comboKitItemsNames, comboKitNumberOfItemsMessage }) => (
  <>
    <ProductDescription key={0} className={'productDescription simple'}>
      {comboKitItemsNames.map((comboKitItemName, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={i} className={'nowrap wide'}>
          <i className={'dcg-icon-circle-plus'} />
          {comboKitItemName}
        </li>
      ))}
    </ProductDescription>
    <h5 key={1} className={'brand'}>
      {comboKitNumberOfItemsMessage}
    </h5>
  </>
);

ListItemOutfitsInfo.propTypes = {
  comboKitItemsNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  comboKitNumberOfItemsMessage: PropTypes.string.isRequired
};

export default ListItemOutfitsInfo;
